import adminTable from "@store/adminTable/reducers";

import { question_dashboard } from "@Modules/Dashboard/configs/constants";

export default adminTable(question_dashboard);
